export default {
  title_unknown: "Unknown Identifier",
  text1_unknown: 'You scanned an unknown <b class="text-info">Identifier</b>!',
  text2_unknown:
    'For new- or re-association between Identifiers and <b class="text-info">Items</b>, <b class="text-info">Areas</b> or <b class="text-info">Locations</b>, first find their Overview via the relevant list and use the <i class="fa-solid fa-ellipsis-vertical"></i> Context menu!',
  title_associate: "Associated Identifier Scanned!",
  text1_associate:
    'You scanned an <b class="text-info">Identifier</b> that is already associated with <b>{entity_old}</b>.',
  text2_associate:
    'Do you want to remove that association and change the association of this <b class="text-info">Identifier</b> to <b>{entity_new}</b>?',
}
